import request from '@/utils/request'

export function findProfiles(params) {
  return request({
    url: `/customer/profiles`,
    method: 'get',
    params
  })
}

export function findDownloadableProfileOptions(params) {
  return request({
    url: `/customer/profiles/downloadable_options`,
    method: 'get',
    params
  })
}

export function updateProfileEimData(id) {
  return request({
    url: `/customer/profiles/${id}/eim_data`,
    method: 'post'
  })
}
